import React from "react";
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordInput({ setValue }) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="relative w-full bg-white">
      <input
        type={showPassword ? "text" : "password"}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Enter your password"
        className="w-full px-4 py-2 border rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10 bg-white"
      />
      <button
        type="button"
        onClick={() => setShowPassword((prev) => !prev)}
        className="absolute right-3 top-2.5 text-gray-500 hover:text-gray-700 focus:outline-none"
      >
        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
      </button>
    </div>
  );
}
